/*
 * useEnhancedEffect  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useEffect, useLayoutEffect } from "react";
import { isSSR } from "../utils/isSSR";

export const useEnhancedEffect = isSSR() ? useEffect : useLayoutEffect;
